// Random helper functions

export function roundTo(n, digits) {
  var negative = false;
  if (digits === undefined) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(digits);
  if (negative) {
    n = (n * -1).toFixed(digits);
  }
  return n;
}

export function formatTime(totalSeconds) {
  if (!totalSeconds) return;
  const [s, ms] = totalSeconds.toString().split('.');
  const milli = !ms ? '' : `.${ms}`;
  let minutes = Math.floor(s / 60);
  const seconds = s % 60;
  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  // minutes = minutes > 0 ? `${padTo2Digits(minutes)}:` : '';
  const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}${milli}`;
  return result;
}

export function fmtMSS(s) {
  return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
}

export function millisecondFix(min_sec_msec) {
  const res = min_sec_msec.split('.');
  let msec = res[1] + '000';
  msec = msec.slice(0, 3);
  const result = `${res[0]}.${msec}`;
  return result;
}

// move to helpers
export function mySum(a, b, positions) {
  const factor = Math.pow(10, positions);
  return (
    (a.toFixed(positions) * factor + b.toFixed(positions) * factor) / factor
  );
}

/**
 * Adjusts a number to the specified digit.
 *
 * @param {"round" | "floor" | "ceil"} type The type of adjustment.
 * @param {number} value The number.
 * @param {number} exp The exponent (the 10 logarithm of the adjustment base).
 * @returns {number} The adjusted value.
 */
function decimalAdjust(type, value, exp) {
  type = String(type);
  if (!['round', 'floor', 'ceil'].includes(type)) {
    throw new TypeError(
      "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'."
    );
  }
  exp = Number(exp);
  value = Number(value);
  if (exp % 1 !== 0 || Number.isNaN(value)) {
    return NaN;
  } else if (exp === 0) {
    return Math[type](value);
  }
  const [magnitude, exponent = 0] = value.toString().split('e');
  const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
  // Shift back
  const [newMagnitude, newExponent = 0] = adjustedValue.toString().split('e');
  return Number(`${newMagnitude}e${+newExponent + exp}`);
}

// Decimal round
export const round10 = (value, exp) => decimalAdjust('round', value, exp);
// Decimal floor
export const floor10 = (value, exp) => decimalAdjust('floor', value, exp);
// Decimal ceil
export const ceil10 = (value, exp) => decimalAdjust('ceil', value, exp);

export function rhUtc2pst(racehero_utc_time_string, show_time = false) {
  // const inputString = "2022-10-30 17:55:26 UTC";
  // but apparently also: 2023-07-30T22:50:00.000Z
  const inputString = racehero_utc_time_string;
  let localDate;
  if (!inputString.endsWith('Z')) {
    // Extract the date and time parts
    const [datePart, timePart] = inputString.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute, second] = timePart.split(':');
    // Create a Date object in local time
    localDate = new Date(
      `${year}-${month}-${day}T${hour}:${minute}:${second}Z`
    );
  } else {
    localDate = new Date(inputString);
  }
  // Convert local time to UTC time string
  const utcTimeString = localDate.toISOString();
  // Create a Date object from the UTC time string
  const utcDate = new Date(utcTimeString);

  const options = show_time
    ? {
        timeZone: 'America/Los_Angeles',
        dateStyle: 'full',
        timeStyle: 'long',
      }
    : {
        timeZone: 'America/Los_Angeles',
        dateStyle: 'full',
      };

  // Convert UTC time to Pacific Time
  const pacificTime = new Intl.DateTimeFormat('en-US', options).format(utcDate);
  return pacificTime;
}

export function fullNameSplit(fullname) {
  const nameArray = fullname.split(' ');
  return {
    firstName: nameArray[0],
    lastName: nameArray.slice(-1),
    // initials: `${nameArray[0].charAt(0)}${nameArray.slice(-1).charAt(0)}`,
  };
}

export function epochToLocalTime(epochtime) {
  var d = new Date(epochtime * 1000);
  return d;
}
